var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(-1.25 -1.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49044",
    "data-name": "Path 49044",
    d: "M13.25,25.25a12,12,0,1,1,12-12,12,12,0,0,1-12,12Zm0-22.326A10.326,10.326,0,1,0,23.576,13.25,10.326,10.326,0,0,0,13.25,2.924Z",
    transform: "translate(0 0)",
    fill: "#0464ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49045",
    "data-name": "Path 49045",
    d: "M12.087,17.506a.837.837,0,0,1-.837-.837V11.087a.837.837,0,0,1,1.674,0v5.581A.837.837,0,0,1,12.087,17.506Z",
    transform: "translate(1.163 1.047)",
    fill: "#0464ab"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_67",
    "data-name": "Ellipse 67",
    cx: 1.116,
    cy: 1.116,
    r: 1.116,
    transform: "translate(12.134 7.669)",
    fill: "#0464ab"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.078a5a0ac338ce3b8da1c1a4925b1453.svg";
export { ForwardRef as ReactComponent };